import { useCallback } from 'react';

import { useRequirementState } from './useRequirementState';
import { EditableCondition } from '../../types';

export const useRequirementConditionsState = () => {
  const {
    requirement: {
      searchCombo: { searchQueries: conditions = [] } = {},
    },
    setRequirement,
  } = useRequirementState();
  const setConditions = useCallback(
    (setterFn: (currentConditions: EditableCondition[]) => EditableCondition[]) =>
      setRequirement((requirement) => ({
        ...requirement,
        searchCombo: {
          ...requirement.searchCombo,
          searchQueries: setterFn(requirement.searchCombo?.searchQueries ?? []),
        },
      })),
    [setRequirement],
  );
  return {
    conditions,
    setConditions,
  };
};
